import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"; 

gsap.registerPlugin(ScrollTrigger);

import AOS from 'aos';
import 'aos/dist/aos.css';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


const pageAnim = (() => {
  const homeAos = () => {
    AOS.init();
  };
  const homeDonateClipAim = () => {

    const homeSlides = document.querySelectorAll(".home-slide-container .swiper-slide picture img");
    const nextSection = document.querySelector(".home-next-section");
    const donateMethods = document.querySelectorAll('.home-donate-method, .home-news, .home-donate');
    const slideLeftOvalBg = document.querySelector(".home-slide-number .bg");
    const items = document.querySelectorAll(".home-hk .hk-list .list .item");
    const leftOvalBg = document.querySelectorAll(".left-oval-bg");
    const shadowElementsHorizontal = document.querySelectorAll(".shadow-horizontal");
    const shadowElementsVertical = document.querySelectorAll(".shadow-vertical");
    const shadowElementUp = document.querySelectorAll(".sh-anim.up, .sh-anim.up-right, .sh-anim.right-p-down");
    const shadowElementDown = document.querySelectorAll(".sh-anim.down");
    const serviceBlocks = document.querySelectorAll('.service-block');
    const donateMethodItem = document.querySelectorAll('.donate-method-item');
    const donateMethodForm = document.querySelectorAll('.donate-method-form');
    const donateMethodFormImg1 = document.querySelectorAll('.donate-method-form-img .img-1');
    const donateMethodFormImg2 = document.querySelectorAll('.donate-method-form-img .img-2');
    const donateMethodFormAnimSvg = document.querySelectorAll('.donate-method-form-img .anim-svg');

    
    //resize
    let currentWidth = window.innerWidth;
    let isMobile = currentWidth <= 769;

    window.addEventListener('resize', () => {
      const newWidth = window.innerWidth;
      const newIsMobile = newWidth <= 769;
      
      // Eğer mobile/desktop geçişi olduysa sayfayı yenile
      if (isMobile !== newIsMobile) {
        window.location.reload();
      }
      
      currentWidth = newWidth;
      isMobile = newIsMobile;
    });

    if(window.innerWidth > 769){

      homeSlides.forEach(slide => {
        gsap.to(slide, {
          scrollTrigger: {
            trigger: slide,
            start: "top top",
            end: "bottom top",
            scrub: true,
          },
          y: "30%",
          ease: "none",
        });
      });
    
      donateMethodItem.forEach((item) => {
        gsap.fromTo(
          item,
          { y: 100, opacity: 0 },
          { 
            y: 0, 
            opacity: 1, 
            duration: 1.1, 
            ease: "power3.out",
            scrollTrigger: {
              trigger: item,
              start: "top 200%",
              toggleActions: "play none none none",
              scrub: true,
            }
          }
        );
      });
    
      donateMethodForm.forEach((form) => {
        gsap.fromTo(
          form,
          { x: 100, opacity: 0 },
          { 
            x: 0, 
            opacity: 1, 
            duration: 1.1, 
            ease: "power3.out",
            scrollTrigger: {
              trigger: form,
              start: "top 200%",
              toggleActions: "play none none none",
              scrub: true,
            }
          }
        );
      });


      gsap.to(donateMethodFormImg1, {
        scrollTrigger: {
          trigger: donateMethodFormImg1,
          start: "top bottom+=150px",
          end: "bottom top",
          scrub: true,
        },
        y: -50,
        ease: "none"
      });


      gsap.to(donateMethodFormImg2, {
        scrollTrigger: {
          trigger: donateMethodFormImg2,
          start: "top bottom+=150px",
          end: "bottom top",
          scrub: true,
        },
        y: -50,
        ease: "none"
      });


      gsap.to(donateMethodFormAnimSvg, {
        scrollTrigger: {
          trigger: donateMethodFormAnimSvg,
          start: "top bottom+=150px",
          end: "bottom top",
          scrub: true,
        },
        y: -150,
        ease: "none"
      });
      
      // slide arrow
      // if(nextSection){
      //   gsap.set(nextSection, { bottom: 0 });
      //   gsap.to(nextSection, {
      //     scrollTrigger: {
      //       trigger: nextSection,
      //       start: "top bottom-=150px", // Sayfa başındaki trigger noktası
      //       end: "bottom top",   // Sayfa sonundaki trigger noktası
      //       scrub: true,         // Scroll ile animasyonu senkronize et
      //       onUpdate: (self) => {
      //         const progress = self.progress;
      //         const newBottom = -150 * progress; // 0'dan -150px'e kadar bottom değeri
      //         gsap.set(nextSection, { bottom: newBottom }); // bottom değerini güncelle
      //       }
      //     }
      //   });
      // }
      
        // home hk item
        items.forEach(item => {
          gsap.to(item, {
            scrollTrigger: {
              trigger: item,       // Animasyonun tetikleneceği öğe
              start: "top bottom-=250px", // Animasyon başlangıç noktası
              end: "bottom top",   // Animasyon bitiş noktası
              scrub: true,         // Scroll ile senkronize animasyon
            },
            backgroundPosition: "50% 100%", // Arka plan pozisyonunu değiştirme (başlangıç %50, bitiş %100)
            ease: "none"                    // Sabit hız
          });
        });
      
        // if(nextSection){
        //   gsap.set(nextSection, { bottom: 0 });
        
        //   // GSAP animasyonu ile scroll hareketi ile bottom değerini değiştirelim
        //   gsap.to(nextSection, {
        //     scrollTrigger: {
        //       trigger: nextSection,
        //       start: "top bottom-=150px", // Sayfa başındaki trigger noktası
        //       end: "bottom top",   // Sayfa sonundaki trigger noktası
        //       scrub: true,         // Scroll ile animasyonu senkronize et
        //       onUpdate: (self) => {
        //         const progress = self.progress;
        //         const newBottom = -150 * progress; // 0'dan -150px'e kadar bottom değeri
        //         gsap.set(nextSection, { bottom: newBottom }); // bottom değerini güncelle
        //       }
        //     }
        //   });
        // }

      // home donate method
      // gsap.to(".home-donate-method", {
      //   backgroundColor: "rgb(0, 137, 165)",
      //   scrollTrigger: {
      //     trigger: ".home-donate-method",
      //     start: "top bottom",
      //     end: "bottom bottom",
      //     scrub: true,
      //     markers: false,
      //   },
      //   ease: "none"
      // });
      const slides = document.querySelectorAll(".donate-method-slide .swiper-slide");
      slides.forEach((slide, index) => {
        gsap.fromTo(
          slide,
          {
            opacity: 0,   
            y: 50,
          },
          {
            opacity: 1,
            y: 0,
            delay: index * 0.2,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: slide,
              start:"top 80%",
              // start: "top bottom",
              // end: "bottom bottom",
              // scrub: true,
            },
          }
        );
      });
      // donateMethods.forEach((donateMethod) => {
      //   // İlk durum: clipPath'i 75% olarak ayarla
      //   gsap.set(donateMethod, { 
      //     clipPath: "inset(75%)"
      //   });
      
      //   // ScrollTrigger ile animasyon
      //   gsap.to(donateMethod, {
      //     scrollTrigger: {
      //       trigger: donateMethod, 
      //       start: "top bottom-=150px",
      //       end: "top center-=150px",
      //       scrub: true, 
      //       // markers: true, // Test için tetikleme noktalarını göstermek isterseniz açın
      //     },
      //     clipPath: "inset(0%)",
      //     ease: "none",
      //   });
      // });

      // home-slide left bg
      gsap.to(slideLeftOvalBg, {
        scrollTrigger: {
          trigger: slideLeftOvalBg,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
        y: 300,
        ease: "none"
      });

      leftOvalBg.forEach((leftOvalBgH) => {
        gsap.to(leftOvalBgH, {
          scrollTrigger: {
            trigger: leftOvalBgH,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
        },
        y: 300, // Yukarı doğru 200 piksel hareket
          ease: "none" // Sabit hızda hareket
        });
      });

      shadowElementUp.forEach((shadowElementUpH) => {
        gsap.to(shadowElementUpH, {
          scrollTrigger: {
            trigger: shadowElementUpH,
            start: "top bottom+=150px",
            end: "bottom top",
            scrub: true,
        },
          y: -400,
          ease: "none"
        });
      });

      gsap.to(shadowElementDown, {
        scrollTrigger: {
          trigger: shadowElementDown,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
        y: 400,
        ease: "none" 
      });

      shadowElementsHorizontal.forEach((shadowHorizontal) => {
        gsap.fromTo(shadowHorizontal, 
          { width: "40%" },
          { 
            width: "85%",
            duration: 1.5,
            ease: "power2.out",
            scrollTrigger: {
              trigger: shadowHorizontal,
              start: "top 80%",
              end: "top 50%",
              scrub: true,
              markers: false
            }
          }
        );
      });

      shadowElementsVertical.forEach((shadowVertical) => {
        gsap.fromTo(shadowVertical, 
          { height: "40%" },
          { 
            height: "85%",
            duration: 1.5,
            ease: "power2.out",
            scrollTrigger: {
              trigger: shadowVertical,
              start: "top 80%",
              end: "top 50%",
              scrub: true,
              markers: false
            }
          }
        );
      });

      const tabItems = document.querySelectorAll('.top-right-tabs .a-tab-item');

      tabItems.forEach((tabItem, index) => {
        gsap.fromTo(
          tabItem,
          {
            opacity: 0,
            y: 20, 
          },
          {
            opacity: 1,
            y: 0,
            delay: index * 0.2,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: tabItem,
              start: "top 80%",
              // scrub: true,
            },
          }
        );
      });

      const tbCarousel = document.querySelectorAll(".tb-carousel");

      tbCarousel.forEach((tbCarouselH) => {
        gsap.fromTo(
          tbCarouselH,
          { y: 100, opacity: 0 },
          { 
            y: 0, 
            opacity: 1, 
            duration: 1.5, 
            ease: "power3.out",
            scrollTrigger: {
              trigger: tbCarouselH,
              start: "top 100%",
              toggleActions: "play none none none", 
              scrub: false,
            }
          }
        );
      });

      const homeSupportItem = document.querySelectorAll(".home-supporters .item");

      homeSupportItem.forEach((homeSupportItemH, index) => {
        gsap.fromTo(
          homeSupportItemH,
          {
            opacity: 0,
            y: 20, 
          },
          {
            opacity: 1,
            y: 0,
            delay: index * 0.2,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: homeSupportItemH,
              start: "top 80%",
              end: "bottom 30%",
              scrub: true,
            },
          }
        );
      });

      const headings = document.querySelectorAll(".h2-t-anim");

        headings.forEach((heading) => {
          gsap.fromTo(
            heading,
            { y: 100, opacity: 0 },
            { 
              y: 0, 
              opacity: 1, 
              duration: 1.5, 
              ease: "power3.out",
              scrollTrigger: {
                trigger: heading,
                start: "top 100%",
                toggleActions: "play none none none", 
                scrub: true,
              }
            }
          );
        });

        const headingsTpTitle = document.querySelectorAll(".h2-t-top-anim");
    
        headingsTpTitle.forEach((heading) => {
          gsap.fromTo(
            heading,
            { y: 100, opacity: 0 },
            { 
              y: 0, 
              opacity: 1, 
              duration: 1.1, 
              ease: "power3.out",
              scrollTrigger: {
                trigger: heading,
                start: "top 100%",
                toggleActions: "play none none none",
                scrub: true,
              }
            }
          );
        });

        const rightShAnim = document.querySelectorAll(".t-right-anim");
    
        rightShAnim.forEach((heading) => {
          gsap.fromTo(
            heading,
            { x: 100, opacity: 0 },
            { 
              x: 0, 
              opacity: 1, 
              duration: 1.1, 
              ease: "power3.out",
              scrollTrigger: {
                trigger: heading,
                start: "right 100%",
                toggleActions: "play none none none",
                scrub: true,
              }
            }
          );
        });

        const leftShAnim = document.querySelectorAll(".t-left-anim");
    
        leftShAnim.forEach((heading) => {
          gsap.fromTo(
            heading,
            { x: -100, opacity: 0 },
            { 
              x: 0, 
              opacity: 1, 
              duration: 1.1, 
              ease: "power3.out",
              scrollTrigger: {
                trigger: heading,
                start: "left 100%",
                toggleActions: "play none none none",
                scrub: true,
              }
            }
          );
        });

        const counters = document.querySelectorAll(".counter");

        counters.forEach((counter) => {
          const targetValue = Number(counter.getAttribute("data-target").replace(",", ".")) || 0;
          const decimals = counter.getAttribute("data-target").includes(".") || counter.getAttribute("data-target").includes(",");

          ScrollTrigger.create({
            trigger: counter,
            start: "top 80%",
            onEnter: () => {
              let currentValue = 0;
              const increment = targetValue / 100;

              const updateCounter = () => {
                if (currentValue < targetValue) {
                  currentValue += increment;
                  if (decimals) {
                    counter.textContent = currentValue.toLocaleString("tr-TR", {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    });
                  } else {
                    counter.textContent = Math.floor(currentValue).toLocaleString("tr-TR");
                  }
                  requestAnimationFrame(updateCounter);
                } else {
                  if (decimals) {
                    counter.textContent = targetValue.toLocaleString("tr-TR", {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    });
                  } else {
                    counter.textContent = targetValue.toLocaleString("tr-TR");
                  }
                }
              };

              updateCounter();
            },
          });
        });

        
        const donateLeftAnimSvg = document.querySelector(".home-donate .left-anim");

        gsap.to(donateLeftAnimSvg, {
          scrollTrigger: {
            trigger: donateLeftAnimSvg,
            start: "top center",
            end: "bottom top",
            scrub: true,
          },
          marginTop: "300px",
          ease: "none"
        });
        
        const donateRightAnimSvg = document.querySelector(".home-donate .right-anim");

        gsap.to(donateRightAnimSvg, {
          scrollTrigger: {
            trigger: donateRightAnimSvg,
            start: "top center",
            end: "bottom top",
            scrub: true,
          },
          marginTop: "-300px",
          ease: "none"
        });
        
        const donateLeftAnimImg = document.querySelector(".home-donate .left-image");

        gsap.to(donateLeftAnimImg, {
          scrollTrigger: {
            trigger: donateLeftAnimImg,
            start: "top center",
            end: "bottom top",
            scrub: true,
          },
          marginTop: "-150px",
          ease: "none"
        });
        
        const donateRghtAnimImg = document.querySelector(".home-donate .right-image");

        gsap.to(donateRghtAnimImg, {
          scrollTrigger: {
            trigger: donateRghtAnimImg,
            start: "top center",
            end: "bottom top",
            scrub: true,
          },
          marginTop: "150px",
          ease: "none"
        });
    }


      // const parallaxImages = document.querySelectorAll(".r-parallax-img");

      // parallaxImages.forEach((image) => {
      //   gsap.to(image, {
      //     y: -100, 
      //     ease: "none", 
      //     scrollTrigger: {
      //       trigger: image,
      //       start: "top bottom",
      //       end: "bottom top",
      //       scrub: true,
      //     },
      //   });
      // });


    // serviceBlocks.forEach((block) => {
    //   const targetHeight = parseInt(block.dataset.topHeight);
    //   const originalHeight = block.getBoundingClientRect().height;
  
    //   gsap.fromTo(block,
    //     { height: originalHeight },
    //     {
    //       height: targetHeight,
    //       scrollTrigger: {
    //         trigger: block,
    //         start: () => `top ${window.innerHeight / 2}px`,
    //         end: () => `top ${window.innerHeight / 2 - originalHeight}px`,
    //         scrub: true,
    //         markers: false,
    //       },
    //       ease: "power2.out"
    //     }
    //   );
    // });
    
  };

  const homeDonateMethod = () => {
    // document.querySelectorAll('.donate-method-item').forEach(item => {
    //   item.addEventListener('click', function() {
    //     document.querySelectorAll('.donate-method-item').forEach(i => i.classList.remove('active'));
    //     this.classList.add('active');
    //   });
    // });
    document.querySelectorAll('.donate-price-inp .item').forEach(item => {
      item.addEventListener('click', function() {
        document.querySelectorAll('.donate-price-inp .item').forEach(i => i.classList.remove('active'));
        this.classList.add('active');
      });
    });
  };

  const servicesItemCalculate = () => {
    const serviceBlocks = document.querySelectorAll('.service-block');
    const parentDiv = document.querySelector('.home-our-service');
    const thirdBlock = serviceBlocks[2]; 
    if(thirdBlock){
      const stickyPos = parseInt(getComputedStyle(thirdBlock).getPropertyValue('--data-sticky-pos'));

      window.addEventListener('scroll', () => {
        const blockTop = thirdBlock.getBoundingClientRect().top;
        if (blockTop <= stickyPos && blockTop >= -thirdBlock.offsetHeight) {
          parentDiv.classList.add('sticky-active');
        } else {
          parentDiv.classList.remove('sticky-active');
        }
      });
    }
  };

  const lightboxGallery = () => {
    Fancybox.bind('[data-fancybox]', {
      Thumbs : {
        showOnStart: false
      }
    }); 
  };

  const phoneCustomMarsk = () => {
    // document.addEventListener('DOMContentLoaded', () => {
    //   const phoneInputs = document.querySelectorAll('.phone-mask'); // '.phone-mask' sınıfına sahip input'ları seç
    
    //   phoneInputs.forEach(phoneInput => {
    //     phoneInput.addEventListener('input', function(event) {
    //       let value = event.target.value.replace(/\D/g, '');
    
    //       if (value.length > 0 && value[0] !== '0') {
    //         value = '0' + value;
    //       }
    //       if (value.length > 4) {
    //         value = value.slice(0, 4) + ' ' + value.slice(4);
    //       }
    //       if (value.length > 8) {
    //         value = value.slice(0, 8) + ' ' + value.slice(8); 
    //       }
    //       if (value.length > 13) {
    //         value = value.slice(0, 13);
    //       }
    //       event.target.value = value;
    //     });
    //   });
    // });
  };

  const leftMenuScroll = () => {
    // document.addEventListener("DOMContentLoaded", () => {
    //   const links = document.querySelectorAll(".menu-nav a");
    //   const sections = [...links].map(link => document.getElementById(link.getAttribute("href").substring(1)));
    
    //   const handleScroll = () => {
    //     let scrollPosition = window.scrollY + 130; // Offset'i hesaba katıyoruz
    
    //     sections.forEach((section, index) => {
    //       if (section.offsetTop <= scrollPosition && section.offsetTop + section.offsetHeight > scrollPosition) {
    //         links.forEach(link => link.parentElement.classList.remove("active"));
    //         links[index].parentElement.classList.add("active");
    //       }
    //     });
    //   };
    
    //   links.forEach((link) => {
    //     link.addEventListener("click", (event) => {
    //       event.preventDefault();
    //       const targetId = link.getAttribute("href").substring(1);
    //       const targetElement = document.getElementById(targetId);
    
    //       if (targetElement) {
    //         const offset = -120;
    //         const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    //         window.scrollTo({ top: elementPosition + offset, behavior: "smooth" });
    //       }
    //     });
    //   });
    
    //   window.addEventListener("scroll", handleScroll);
    // });
  };

  const pageFormPassword = () => {
    if(document.querySelector('.password-field')){
      const passwordInput = document.querySelectorAll('.password-field');
      const showPassButtons = document.querySelectorAll('.show-pass');

      showPassButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          const input = passwordInput[index];
          if (input.type === 'password') {
            input.type = 'text';
          } else {
            input.type = 'password';
          }
        });
      });
    }
  };

  const accountLeftMenuAnim = () => {
    $(".account-left-menu-collapse svg").on("click", function() {
      $(".account-left-menu").toggleClass("hide-menu");
    });
  };

  const paymentInfoFormInputPlusMinus = () => {
    $(".custom-piece-box").each(function() {
      const $box = $(this);
      const $input = $box.find(".custom-piece-box-input");
      const $plusBtn = $box.find(".plus-btn");
      const $minusBtn = $box.find(".minus-btn");
      
      // Input'un data-maxlength ve data-minlength değerlerini al
      const maxValue = parseInt($input.data("maxlength")) || 999;
      const minValue = parseInt($input.data("minlength")) || 1;
      
      // Plus butonuna tıklandığında
      $plusBtn.on("click", function() {
        let currentValue = parseInt($input.val()) || minValue;
        if (currentValue < maxValue) {
          currentValue++;
          $input.val(currentValue);
        }
      });
      
      // Minus butonuna tıklandığında
      $minusBtn.on("click", function() {
        let currentValue = parseInt($input.val()) || minValue;
        if (currentValue > minValue) {
          currentValue--;
          $input.val(currentValue);
        }
      });
    });
  };

  const init = () => {
    homeAos();
    homeDonateClipAim();
    homeDonateMethod();
    servicesItemCalculate();
    lightboxGallery();
    phoneCustomMarsk();
    leftMenuScroll();
    pageFormPassword();
    accountLeftMenuAnim();
    paymentInfoFormInputPlusMinus();
  };

  return {
    init,
  };
})();

export default pageAnim;
